import { createSlice } from "@reduxjs/toolkit";
import {
  inviteTeamMemberClient,
  getTeamMembers,
  validateInvitationToken,
  removeTeamMemberClient,
  acceptInvitationExistingUser,
} from "../thunks/teamMemberClientThunks";

const initialState = {
  teamMembers: [],
  invitationData: null,
  loading: false,
  error: null,
  acceptanceStatus: null,
};

const teamMemberSlice = createSlice({
  name: "teamMember",
  initialState,
  reducers: {
    clearInvitationData: (state) => {
      state.invitationData = null;
    },
    clearError: (state) => {
      state.error = null;
    },
    clearAcceptanceStatus: (state) => { 
      state.acceptanceStatus = null;
    },
    // Add reducer to sync team members from company profile
    setTeamMembers: (state, action) => {
      state.teamMembers = Array.isArray(action.payload) ? action.payload : [];
    },
  },
  extraReducers: (builder) => {
    builder
      // Invite team member
      .addCase(inviteTeamMemberClient.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(inviteTeamMemberClient.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(inviteTeamMemberClient.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      
      // Get team members
      .addCase(getTeamMembers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getTeamMembers.fulfilled, (state, action) => {
        state.loading = false;
        console.log('getTeamMembers payload:', action.payload);
        // Ensure we're setting an array - handle both direct array and nested data structure
        const teamMembersData = action.payload?.data.members || action.payload;
        state.teamMembers = Array.isArray(teamMembersData) ? teamMembersData : [];
        console.log('Final state.teamMembers:', state.teamMembers);
      })
      .addCase(getTeamMembers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        // Reset to empty array on error
        state.teamMembers = [];
      })
      
      // Validate invitation
      .addCase(validateInvitationToken.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(validateInvitationToken.fulfilled, (state, action) => {
        state.loading = false;
        state.invitationData = action.payload;
      })
      .addCase(validateInvitationToken.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      
      // Remove team member
      .addCase(removeTeamMemberClient.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(removeTeamMemberClient.fulfilled, (state, action) => {
        state.loading = false;
        console.log('Removing team member, current state.teamMembers:', state.teamMembers);
        console.log('Action payload:', action.payload);
        
        try {
          // Initialize teamMembers as empty array if it's not already an array
          if (!Array.isArray(state.teamMembers)) {
            console.warn('state.teamMembers is not an array, initializing:', state.teamMembers);
            state.teamMembers = [];
          } else {
            // Filter out the removed team member
            state.teamMembers = state.teamMembers.filter(
              (member) => member.id !== action.payload.memberId
            );
            console.log('Filtered teamMembers:', state.teamMembers);
          }
        } catch (error) {
          console.error('Error updating teamMembers state:', error);
          // Fallback: reset to empty array to prevent further errors
          state.teamMembers = [];
        }
      })
      .addCase(removeTeamMemberClient.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Accept invitation for existing user
      .addCase(acceptInvitationExistingUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(acceptInvitationExistingUser.fulfilled, (state, action) => {
        state.loading = false;
        state.acceptanceStatus = 'success';
      })
      .addCase(acceptInvitationExistingUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.acceptanceStatus = 'failed';
      });
  },
});

export const { clearInvitationData, clearError, clearAcceptanceStatus, setTeamMembers } = teamMemberSlice.actions;
export default teamMemberSlice.reducer;